import axios from "axios";

const rawBase = (
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  process.env.REACT_APP_BACKEND ||
  "http://localhost:8000/api/v1"
)
  .trim()
  .replace(/([^:]\/)\/+/g, "$1")
  .replace(/\/+$/, "");

const baseUrl = rawBase.includes("/api/v1") ? rawBase : `${rawBase}/api/v1`;

const api = axios.create({
  baseURL: baseUrl
});

export const getRequest = (url, config) => api.get(url, config);
export const postRequest = (url, data, config) => api.post(url, data, config);
export const patchRequest = (url, data, config) => api.patch(url, data, config);
export const deleteRequest = (url, config) => api.delete(url, config);

export default api;
